import {
	Card,
	makeStyles,
	Tooltip, Box,
} from '@material-ui/core';
import * as dayjs from 'dayjs';
import React from 'react';
import { useActions, useValues } from 'kea';
import MUIDataTable from "mui-datatables";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { rtrackerslogic } from 'src/store/report';

import TrackerDataDialog from './AddDataDialogs/HistoryDialog';
import PrintToolbarPlugin from '../../../utils/PDFDialog/PDFToolbarPlugin';
import CSVToolbarPlugin from '../../../utils/CSVDialog/CSVToolbarPlugin';

const useStyles = makeStyles({
	root: {
		width: "100%",
		height: '600px'
	},
	container: {
		maxHeight: '440'
	}
});

const withTooltip = (text) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden'
		}}>
			{text}
		</div>
	</Tooltip >
)

const columns = [
	{
		name: 'enabled',
		label: 'Enabled',
		align: 'left',
		width: 300,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'name',
		label: 'Name',
		align: 'left',
		width: 300,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'info',
		label: 'Vehicle Info',
		align: 'left',
		width: 350,
		options: { customBodyRender: (param) => withTooltip(param) }
	},
	{
		name: 'date_added',
		label: 'Date Added',
		align: 'left',
		width: 300,
		options: {
			filter: false, customBodyRender: (param) => withTooltip(param)
		}
	}
];


const initialRowsPerPage = 10;
const History = () => {
	const classes = useStyles();
	const { report } = useValues(rtrackerslogic);
	const [data, setData] = React.useState([]);

	React.useEffect(() => {
		if (report.length > 0) {
			let newRows = report.map((row, count) => {
				return {
					id: count,
					enabled: row.enabled ? 'Enabled' : 'Disabled',
					name: row.name,
					info: `${row.year} ${row.company} ${row.model} ${row.color}`,
					date_added: `${dayjs(row.createdAt).format('DD MMM YYYY')}`
				}
			});
			setData(newRows);
		} else {
			setData([]);
		}
	}, [report]);

	const options = {
		textLabels: {
			body: {
				noMatch: "No data. Please create a report first using the + button located in the top right corner of this table."
			}
		},
		selectableRows: 'none',
		print: false,
		download: false,
		tableBodyHeight: '100%',
		rowsPerPage: 15,
		customToolbar: (data) =>
			<span >
				{/* <br /> */}
				<PrintToolbarPlugin title='History Report' rows={data} columns={columns} filename={'History_Report'} />
				<CSVToolbarPlugin rows={data} columns={columns} filename={'History_Report'} />
				<TrackerDataDialog />
			</span>
	};
	const getMuiTheme = () => createTheme({
		overrides: {
			MUIDataTableBodyCell: {
				root: {
					padding: "4px"
				}
			}
		}
	})

	return (
		<>
			<Box mt={1}>

				<MuiThemeProvider theme={getMuiTheme()}>
					<MUIDataTable
						title={"Vehicle History Report"}
						data={data}
						columns={columns}
						options={options}
					/>
				</MuiThemeProvider>
			</Box>
		</>
	);
};


export default History;
